import { Component } from "react";

/**
 * A crash should say what happened.
 *
 * React unmounts the whole tree when a render throws, which leaves a blank
 * white page — indistinguishable from a failed deploy, a bad build, or the
 * network being down, and impossible to report usefully. Several faults in this
 * app have presented that way. Here the error and its component stack are shown
 * instead, so the next one takes a minute rather than an hour.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("[cashflow] render failed", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#F2EBDC",
          padding: 32,
          fontFamily: "'Manrope', system-ui, sans-serif",
          color: "#1A1815",
        }}
      >
        <h1 style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 24, marginBottom: 4 }}>
          Something broke while drawing this page
        </h1>
        <p style={{ fontSize: 13, color: "#7A7468", maxWidth: 620, lineHeight: 1.6 }}>
          Nothing has been lost — this is a display fault, not a data one. Reloading often clears
          it. If it doesn't, the detail below says what went wrong.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            margin: "12px 0",
            padding: "8px 16px",
            border: "none",
            borderRadius: 6,
            background: "#2F5D41",
            color: "#fff",
            fontSize: 13,
            cursor: "pointer",
          }}
        >
          Reload
        </button>
        <pre
          style={{
            background: "#fff",
            border: "1px solid #DDD3BE",
            borderRadius: 8,
            padding: 14,
            fontSize: 11,
            overflowX: "auto",
            whiteSpace: "pre-wrap",
            maxHeight: "50vh",
          }}
        >
          {String(this.state.error?.stack || this.state.error)}
          {this.state.info?.componentStack || ""}
        </pre>
      </div>
    );
  }
}
